import { useState } from 'react';

/**
 * Foto do contato, com inicial colorida como rede de segurança.
 *
 * A foto real vem da Evolution (`contatoFoto`), mas ela falha de três jeitos
 * diferentes: o contato pode não ter foto, pode tê-la restrita por privacidade,
 * e a URL do CDN da Meta EXPIRA. Por isso o `onError` não é zelo — é o caminho
 * comum depois de alguns dias.
 *
 * A inicial nunca falha: sai do nome que a tela já mostra.
 */

/**
 * Cor estável a partir do nome.
 *
 * Precisa ser determinística: se a cor sorteasse a cada render, o mesmo contato
 * mudaria de cor ao rolar a lista, e a cor deixaria de servir para reconhecer
 * alguém de relance — que é a única função dela.
 *
 * Paleta escolhida com contraste suficiente para texto branco por cima.
 */
const CORES = [
  '#0f766e', '#0e7490', '#1d4ed8', '#6d28d9', '#a21caf',
  '#be123c', '#c2410c', '#a16207', '#4d7c0f', '#15803d',
];

export function corDoNome(nome) {
  const texto = String(nome ?? '');
  let soma = 0;
  for (let i = 0; i < texto.length; i += 1) soma = (soma + texto.charCodeAt(i) * (i + 1)) % 9973;
  return CORES[soma % CORES.length];
}

/** Primeira letra visível do nome; '?' quando não há nada aproveitável. */
export function inicialDoNome(nome) {
  const limpo = String(nome ?? '').trim();
  // Nome que é telefone ("+5562...") daria "+" como inicial — inútil.
  const primeiraLetra = limpo.match(/\p{L}/u);
  return (primeiraLetra?.[0] ?? '?').toUpperCase();
}

export default function AvatarContato({ foto, nome, tamanho = 40 }) {
  const [falhou, setFalhou] = useState(false);
  const estilo = { width: tamanho, height: tamanho };

  if (foto && !falhou) {
    return (
      <img
        className="avatar-contato"
        style={estilo}
        src={foto}
        alt=""
        loading="lazy"
        onError={() => setFalhou(true)}
      />
    );
  }

  return (
    <span
      className="avatar-contato inicial"
      style={{ ...estilo, background: corDoNome(nome) }}
      aria-hidden="true"
    >
      {inicialDoNome(nome)}
    </span>
  );
}
